import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import styles from './DocumentUpload.style';

const DocumentUpload = forwardRef(
  ({ children, className: classNameProp, onUpload, accept, id, ...other }, ref) => {
    const className = classNameProp;
    return (
      <div className={className}>
        <label htmlFor="upload">
          <Text className={styles.text} as="a">
            {children || (
              <>
                <FontIcon iconName="Attach" className={styles.icon} />{' '}
                <span>Attach Documentation</span>
              </>
            )}
          </Text>
          <input
            ref={ref}
            className={styles.input}
            onChange={val => onUpload(val.target.files)}
            id={id}
            type="file"
            name="upload"
            accept={accept}
            aria-label="upload"
            {...other}
          />
        </label>
      </div>
    );
  },
);

DocumentUpload.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  onUpload: PropTypes.func.isRequired,
  accept: PropTypes.string,
  id: PropTypes.string.isRequired,
};

DocumentUpload.defaultProps = {
  className: '',
  children: 'Upload Document',
  accept: null,
};

export default DocumentUpload;
